import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Messages } from '../../../common/constants/messages';
import { FaqService } from '../../services/faq.service';

@Component({
  selector: 'app-faq',
  imports: [
    CommonModule, NgxSpinnerModule
  ],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor(private faqService: FaqService,
    private ngx: NgxSpinnerService,
    private router: Router,
    private location: Location
  ) { }
  companyId: any;
  isLoggedIn = false;
  activeTopic: string = '';
  hasUserScrolled = false;
  dialogSummary = '';
  dialogMsg = '';
  locListModalDlg = false;
  topics: { key: string, value: any[] }[] = [];
  loading = true;
  ngOnInit() {
    this.companyId = sessionStorage.getItem('companyId') || '';
    this.isLoggedIn = !!this.companyId;
    this.topics = [];
    this.getFaqs();
    window.addEventListener('scroll', () => {
      this.hasUserScrolled = true;
    }, { once: true });
  }

  ngAfterViewInit() {
    this.observeSections();
    document.addEventListener('click', (e: any) => {
      const target = e.target;

      if (target.tagName === 'A' && target.href) {
        target.setAttribute('target', '_blank');
      }
    });
  }

  getFaqs() {
    this.loading = true;
    this.ngx.show();
    this.faqService.getFaqs().subscribe({
      next: (res) => {
        if (res) {
          this.groupFaqs(res);
        }
        this.ngx.hide();
        this.loading = false;
      },
      error: (err) => {
        this.ngx.hide();
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.SaveFailedMessage;
        this.locListModalDlg = true;
        this.loading = false;
      }
    });
  }

  groupFaqs(data: any[]) {
    const filtered = data.filter(item => {
      if (!item.isActive) return false;
      if (!this.isLoggedIn) {
        return item.isDisplayAlways;
      }
      return true;
    });

    const grouped: Record<string, any[]> = {};

    filtered.forEach(item => {
      const topic = item.faqTopicName;

      if (!grouped[topic]) grouped[topic] = [];

      grouped[topic].push(item);
    });

    Object.keys(grouped).forEach(topic => {
      grouped[topic].sort((a, b) => a.displayOrder - b.displayOrder);
    });

    this.topics = Object.keys(grouped)
      .map(key => ({
        key,
        value: grouped[key],
        order: grouped[key][0].faqTopicDisplayOrder
      }))
      .sort((a, b) => a.order - b.order);
  }

  groupByTopic(data: any[]) {
    return data.reduce((acc, item) => {
      if (!acc[item.topic]) acc[item.topic] = [];
      acc[item.topic].push(item);
      return acc;
    }, {});
  }

  scrollTo(id: string) {
    this.activeTopic = id;
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 50);
  }
  openFaqs: string[] = [];

  toggleFaq(ti: number, qi: number) {
    const key = `${ti}-${qi}`;

    if (this.openFaqs.includes(key)) {
      this.openFaqs = this.openFaqs.filter(x => x !== key);
      if (this.openFaqs.length === 0) {
        this.activeTopic = '';
      }

    } else {
      this.openFaqs.push(key);
      this.activeTopic = this.topics[ti].key;
    }
  }

  isOpen(ti: number, qi: number): boolean {
    return this.openFaqs.includes(`${ti}-${qi}`);
  }

  onClose() {
    this.router.navigate(['']);
    //this.location.back();
  }

  observeSections() {
    const sections = document.querySelectorAll('.faq-content h3');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && this.hasOpenFaq()) {
            this.activeTopic = entry.target.id;
          }
        });
      },
      {
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0
      }
    );

    sections.forEach(section => observer.observe(section));
  }

  hasOpenFaq(): boolean {
    return this.openFaqs.length > 0;
  }

  cleanHtml(html: string): string {
    if (!html) return '';

    return html
      // fix broken closing tags
      .replace(/<\/>/g, '</b>')
      .replace(/<b>([^<]*)<\/>/g, '<b>$1</b>')
      .replace(/<b>Mailing address for check payments:<\/>/g, '<b>Mailing address for check payments:</b>')

      //FIX DOUBLE QUOTES ISSUE
      .replace(/""/g, '"')

      //FIX malformed style attribute
      .replace(/style="color: ([^"]+)"/g, 'style="color: $1"')

      //Ensure href is valid
      .replace(/href="([^"]+)"/g, (match, url) => {
        return `href="${url.trim()}"`;
      });
  }
}